import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';

import Typography from "@material-ui/core/Typography/index";
import Sync from '@material-ui/icons/Sync';
import ListaTabla from './Includes/ListaTabla';
import ModalCostoEnvio from './Includes/ModalCostoEnvio';

import {CostoEnvioService} from '../../../../services/_Cat/CostoEnvioService/CostoEnvioService';
import {PopupService} from '../../../../settings/PoPup/PoPup';
import {FieldsJs} from "../../../../settings/General/General";
import {ReactLocalStorageService} from '../../../../settings/ReactLocalStorageService/ReactLocalStorageService';
import Zoom from '@material-ui/core/Zoom/index';
import Add from '@material-ui/icons/Add';
import Fab from "@material-ui/core/Fab/index";
import VistaVacia from "../../../Include/VistaVacia/VistaVacia";

import IntegrationNotistack, {ShowSnackBarsNotistack} from "../../../../settings/IntegrationNotistack/IntegrationNotistack";
import {CONFIG} from "../../../../settings/Config/Config";
import {CatService} from "../../../../services/_Cat/CatService/CatService";


class CostoEnvio extends Component {
	
	state = {
		modal: {
			open: false,
			title: '',
			tipo: ''
		},
		
		id_cat_costo_mensajeria: '',
		id_cat_tipo_mensajeria: '',
		cantidad_pares_inicio: '',
		cantidad_pares_fin: '',
		costo: '',
		activo: false,
		
		listar_cat_costo_envio: [],
		lista_cat_tipo_mensajeria: []
	};
	
	Usr = {};
	
	constructor() {
		super();
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.Listar();
	}
	
	handleChange = (e) => {
		const {value, name, checked, type} = e.target;
		this.setState({
			[name]: type === 'checkbox' ? checked : value
		});
	};
	
	showSnackBars = (type, message) => {
		ShowSnackBarsNotistack(this.props, type, message, null);
	};
	
	ListarMensajeria = () => {
		CatService.ListTipoMensajeria().then((response) => {
			
			this.setState({lista_cat_tipo_mensajeria: response.data});
			
		}).catch((error) => {
			
			this.setState({lista_cat_tipo_mensajeria: []});
			
			this.showSnackBars('error', error.mensaje);
			
		});
	};
	
	Listar = () => {
		CostoEnvioService.Listar().then((response) => {
			
			this.setState({listar_cat_costo_envio: response.data});
			
		}).catch((error) => {
			
			this.setState({listar_cat_costo_envio: []});
			
			this.showSnackBars('error', error.mensaje);
			
		});
	};
	
	delete = (item) => {
		
		let msg = `¿Deseas eliminar el costo de envió con id ${item.id_cat_costo_mensajeria}?`;
		
		PopupService.Confirm(['Cancelar', 'Eliminar'], 'warning', CONFIG.titulo_alert_confirm, msg).then((r) => {
			
			if (r.button === 'Eliminar') {
				CostoEnvioService.Eliminar(item.id_cat_costo_mensajeria).then((response) => {
					
					this.showSnackBars('success', response.mensaje);
					
					this.Listar();
					
				}).catch((error) => {
					
					this.showSnackBars('error', error.mensaje);
					
				});
			}
			
		});
	};
	
	save = () => {
		if (this.state.id_cat_costo_mensajeria > 0) {
			CostoEnvioService.Modificar(this.state).then((response) => {
				this.closeModal();
				this.Listar();
				this.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.showSnackBars('error', error.mensaje);
			});
		} else {
			CostoEnvioService.Agregar(this.state).then((response) => {
				this.closeModal();
				this.Listar();
				this.showSnackBars('success', response.mensaje);
			}).catch((error) => {
				this.showSnackBars('error', error.mensaje);
			});
		}
	};
	
	add = () => {
		this.setState({
			id_cat_costo_mensajeria: '',
			id_cat_tipo_mensajeria: '',
			cantidad_pares_inicio: '',
			cantidad_pares_fin: '',
			costo: '',
			activo: true,
		});
		
		this.openModal('add');
		
	};
	
	edit = (item) => {
		
		this.setState({
			id_cat_costo_mensajeria: item.id_cat_costo_mensajeria || '',
			id_cat_tipo_mensajeria: item.id_cat_tipo_mensajeria || '',
			cantidad_pares_inicio: item.cantidad_pares_inicio || '',
			cantidad_pares_fin: item.cantidad_pares_fin || '',
			costo: item.costo || '',
			activo: (item.activo === 1),
		});
		
		this.openModal('edit');
		
	};
	
	view = (item) => {
		
		this.setState({
			id_cat_costo_mensajeria: item.id_cat_costo_mensajeria || '',
			id_cat_tipo_mensajeria: item.id_cat_tipo_mensajeria || '',
			cantidad_pares_inicio: item.cantidad_pares_inicio || '',
			cantidad_pares_fin: item.cantidad_pares_fin || '',
			costo: item.costo || '',
			activo: (item.activo === 1),
		});
		
		this.openModal('view');
		
	};
	
	openModal = (tipo, form) => {
		this.ListarMensajeria();
		
		let title = "";
		switch (tipo) {
			case 'add':
				title = "Agregar";
				break;
			case 'edit':
				title = "Editar";
				break;
			case 'view':
				title = "Detalle";
				break;
			default:
		}
		this.setState({
			modal: {
				open: true,
				title: title,
				tipo: tipo
			},
			form: form
		});
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false,
				title: '',
				tipo: ''
			}
		})
	};
	
	render() {
		
		return (
			<div className='Catalogos ContaineViewComponet'>
				
				<Fragment>
					
					<ModalCostoEnvio
						modal={this.state.modal}
						form={this.state}
						save={this.save}
						closeModal={this.closeModal}
						handleChange={this.handleChange}
						showSnackBars={this.showSnackBars}
					/>
				
				</Fragment>
				
				<div className={'row-flex margin-30-T margin-30-B'}>
					<div className={'w-100-300-px'}>
						<Typography variant={'h5'} className={'text-left'}>
							Costo de Envió
						</Typography>
					</div>
					<div className={'w-300-px text-right'}>
						{/*{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
							<Fab variant="extended" size="small" color="primary" aria-label="PDF"
							     className={'margin-10-L bg-danger'}>
								<PictureAsPdf className={'margin-5-R px-14'}/>
								PDF
							</Fab>
						) : ''}
						{FieldsJs.inArray([1, 2], this.Usr.id_cat_tipo_usuario) ? (
							<Fab variant="extended" size="small" color="primary" aria-label="Excel"
							     className={'margin-10-L bg-green'}>
								<EventNote className={'margin-5-R px-14'}/>
								Excel
							</Fab>
						) : ''}*/}
						<Fab variant="extended" size="small" color="primary" aria-label="Add"
						     className={'margin-10-L'} onClick={this.Listar}>
							<Sync className={'margin-5-R px-14'}/>
							Actualizar
						</Fab>
					</div>
				</div>
				
				<div className={'form margin-30-B'}>
					
					<Typography variant={'h6'} className={'margin-30-T margin-30-B'}>
					
					</Typography>
					
					{this.state.listar_cat_costo_envio.length > 0 ? (
						<ListaTabla lista={this.state.listar_cat_costo_envio}
						            edit={this.edit}
						            view={this.view}
						            delete={this.delete}
						/>
					) : (
						<VistaVacia
							numero={0}
							mensaje={'No se encontraron datos.'}
						/>
					)}
				
				</div>
				
				<Zoom className={'btn-fixed-bottom-right cursor-pointer'} key={'inherit'} timeout={1500} in={true}
				      style={{transitionDelay: `${100}ms`}} unmountOnExit>
					<Fab color={'primary'} onClick={() => this.add()}>
						<Add/>
					</Fab>
				</Zoom>
			
			</div>
		);
	}
}

CostoEnvio.propTypes = {
};

export default IntegrationNotistack(CostoEnvio);
